(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      /* Epilekton theme has its own compact-on-scroll behavior (see
         initCompactState below) and must NEVER hide the header on
         scroll-down — that "jumping" was caused by Dawn's hide/reveal
         fighting our compact-state CSS transitions. Force always-sticky. */
      this.headerIsAlwaysSticky = true;
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      this.header.classList.add('shopify-section-header-sticky');

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      /* onScroll() / hide / reveal listeners intentionally NOT bound. */

      this.createObserver();
      this.initCompactState();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    initCompactState() {
      var self = this;
      /* WHY THIS IS NOT A SIMPLE THRESHOLD:
         On desktop the compact state collapses the nav-bar + secondary-nav
         rows (~80–120px) that live INSIDE this position:sticky header at the
         top of the document flow. Toggling that collapse changes the document
         height above the fold, so the browser's scroll anchoring shifts
         window.scrollY by roughly the same amount. A narrow hysteresis band
         (the old 50/90) is smaller than that scroll jump, so the shifted
         scrollY immediately re-crosses the threshold and the header strobes.

         Two guards make the toggle stable:
         1. A band WIDER than the largest possible collapse. ENTER is set past
            the full expanded header height so you compact only after the nav
            rows have scrolled away; EXIT sits near the very top so we return
            to full height only when you're basically back at the top. With
            (ENTER - EXIT) larger than the collapse, the post-toggle scroll
            jump always lands safely inside the band and can't re-trigger.
         2. A re-entrancy lock for the length of the CSS collapse transition
            (--dur-base ≈ 220ms), so the scroll-anchor bounce fired mid-
            transition is ignored entirely. */
      var expandedHeight = self.header.offsetHeight || 120;
      var ENTER = expandedHeight + 24;
      var EXIT = 8;
      var locked = false;

      function updateCompact() {
        if (locked) return;
        var y = window.scrollY;
        var prev = self.dataset.state;
        var next = prev === 'compact' ? (y < EXIT ? 'default' : 'compact')
                                       : (y > ENTER ? 'compact' : 'default');
        if (next !== prev) {
          self.dataset.state = next;
          /* Hold the state while the collapse transition — and the scroll-
             anchor adjustment it provokes — settles, then resync
             --header-height so sticky offsets (e.g. PDP gallery) stay aligned. */
          locked = true;
          window.setTimeout(function () {
            locked = false;
            self.setHeaderHeight();
          }, 280);
        }
      }

      /* Re-measure the ENTER threshold against the expanded header whenever the
         viewport changes (breakpoints alter header height). Guard against
         reading a collapsed height by only sampling while in the default state. */
      window.addEventListener('resize', function () {
        if (self.dataset.state !== 'compact') {
          ENTER = (self.header.offsetHeight || 120) + 24;
        }
      }, { passive: true });

      window.addEventListener('scroll', updateCompact, { passive: true });
      updateCompact();
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
